export default "__VITE_ASSET__C0QDgMv8__"